import * as React from "react";
import lb4Provider from "../react-admin-lb4";

import { Admin, Resource } from "react-admin";
import { QuartiersList, QuartiersEdit, QuartiersShow } from "./Quartiers";
import { ProvincesList, ProvincesEdit, ProvincesShow } from "./Provinces";
import { RegionsList, RegionsEdit, RegionsShow } from "./Regions";
import { CommunesList, CommunesEdit, CommunesShow } from "./Communes";
import { PaList, PaEdit, PaShow } from "./Pa";
import { CDPRList, CDPREdit, CDPRShow } from "./CDPR";
import { CDPPList, CDPPEdit, CDPPShow } from "./CDPP";
import { CDPCList, CDPCEdit, CDPCShow } from "./CDPC";
import { CDPCVILLAList, CDPCVILLAEdit, CDPCVILLAShow } from "./CDPCVILLA";
import { CDPPVILLAList, CDPPVILLAEdit, CDPPVILLAShow } from "./CDPPVILLA";

import { CDPRVILLAList, CDPRVILLAEdit, CDPRVILLAShow } from "./CDPRVILLA";

import { CDPQVILLAList, CDPQVILLAEdit, CDPQVILLAShow } from "./CDPQVILLA";

import { CommunesTunisieList, CommunesTunisieEdit, CommunesTunisieShow } from "./CommunesTunisie";

import { RegionsTunisieList, RegionsTunisieEdit, RegionsTunisieShow } from "./RegionsTunisie";
import { SecteursTunisieList, SecteursTunisieEdit, SecteursTunisieShow } from "./SecteursTunisie";

import { AutocompleteList, AutocompleteEdit, AutocompleteShow } from "./Autocomplete";
import { CDPQList, CDPQEdit, CDPQShow } from "./CDPQ";

import { FirebaseAuthProvider } from "react-admin-firebase";
import { firebaseConfig as config } from "./config/FIREBASE_CONFIG";
// import { app } from "../../config/FIREBASE_CONFIG";
import { fetchUtils } from 'react-admin';
// import SimpleRestProvider from 'ra-data-simple-rest';
import firebase from './config/firebase'
console.log(firebase.auth)
const httpClient = (url, options = {}) => {
  authProvider.getAuthUser().then(res => {
    console.log(res)
    res.getIdToken(true).then(res2 => {
      localStorage.setItem('auth', res2)
      console.log(url)
      return fetchUtils.fetchJson(url, options);
    })
  })
    .catch(err => {
      console.log(err)
    })

};
const options = {};
const authProvider = FirebaseAuthProvider(config, options);

const myAuthProvider = {
  ...authProvider,
  login: async (params) => {
    const user = await authProvider.login(params);
    const claims = await authProvider.getPermissions();
    const isAdmin = claims.adminCDP === true;
    console.log(claims);
    if (isAdmin) {
      user.user.getIdToken().then(function (token) {
        console.log(token);
        localStorage.setItem('auth', token)
      });
      return user;
    }
    await authProvider.logout();
    throw new Error("Login error, invalid permissions");
  },
};



class CarteDesPrix extends React.Component {
  render() {
    // console.log(config);
    return (
      <>
        <Admin
          // loginPage={CustomLoginPage}
          // dataProvider={lb4Provider("http://127.0.0.1:4000")}
          // dataProvider={lb4Provider('https://carto.admin.agenz.ma')}
          dataProvider={lb4Provider('https://admin.valuation.agenz.ma/cdp')}
          // dataProvider={lb4Provider("http://127.0.0.1:4000/cdp")}
          authProvider={myAuthProvider}
        >
          <Resource
            name="AutocompleteV2s"
            list={AutocompleteList}
            show={AutocompleteShow}
            edit={AutocompleteEdit}
          />
          <Resource
            name="quartiers"
            list={QuartiersList}
            show={QuartiersShow}
            edit={QuartiersEdit}
          />

          <Resource
            name="provinces"
            list={ProvincesList}
            show={ProvincesShow}
            edit={ProvincesEdit}
          />

          <Resource
            name="regions"
            list={RegionsList}
            show={RegionsShow}
            edit={RegionsEdit}
          />

          <Resource
            name="communes"
            list={CommunesList}
            show={CommunesShow}
            edit={CommunesEdit}
          />

          <Resource
            name="pas"
            list={PaList}
            show={PaShow}
            edit={PaEdit}
          />

          <Resource
            name="CDPRs"
            list={CDPRList}
            show={CDPRShow}
            edit={CDPREdit}
          />

          <Resource
            name="CDPPs"
            list={CDPPList}
            show={CDPPShow}
            edit={CDPPEdit}
          />

          <Resource
            name="CDPCs"
            list={CDPCList}
            show={CDPCShow}
            edit={CDPCEdit}
          />

          <Resource
            name="CDPQs"
            list={CDPQList}
            show={CDPQShow}
            edit={CDPQEdit}

          />
          <Resource
            name="CDPQVILLAs"
            list={CDPQVILLAList}
            show={CDPQVILLAShow}
            edit={CDPQVILLAEdit}
          />
          <Resource
            name="CDPCVILLAs"
            list={CDPCVILLAList}
            show={CDPCVILLAShow}
            edit={CDPCVILLAEdit}
          />

          <Resource
            name="CDPPVILLAs"
            list={CDPPVILLAList}
            show={CDPPVILLAShow}
            edit={CDPPVILLAEdit}
          />

          <Resource
            name="CDPRVILLAs"
            list={CDPRVILLAList}
            show={CDPRVILLAShow}
            edit={CDPRVILLAEdit}
          />

        </Admin>
      </>
    );
  }
}

export default CarteDesPrix;
